import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const BusinessUnitService = {};

// List User
BusinessUnitService.listBusinessUnit = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/business-units?filter[record_status]=O`,
    method: "get",
    params: {
      ...columnFilter,
      // page: params.page || 1,
      // "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      // keywords: params.keywords || "",
      // expand: params.expand || "usprofile,checker",
    },
  });
};

// List User Role
BusinessUnitService.listUserRole = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/users/default-roles`,
    method: "get",
    params: { ...params },
  });
};

// Create User
BusinessUnitService.createBusinessUnit = ({ userCreate }) => {
  return fetch({
    url: `${env.API_MSP}/business-units`,
    method: "post",
    data: {
      ...userCreate,
    },
  });
};
// Update
BusinessUnitService.updateBusinessUnit = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/business-units/${userId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Detail User
BusinessUnitService.detailBusinessUnit = function ({ userId, params }) {
  return fetch({
    url: `${env.API_MSP}/business-units/${userId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "usprofile",
    },
  });
};
// Update User
BusinessUnitService.updateUser = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/users/${userId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete User
BusinessUnitService.deleteBusinessUnit = ({ userId }) => {
  return fetch({
    url: `${env.API_MSP}/business-units/${userId.userId}`,
    method: "delete",
  });
};

// Active User
BusinessUnitService.activeUser = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/users/${userId}/restore`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Detail Config Business Unit
BusinessUnitService.detailConfigBusinessUnit = function ({ buCode }) {
  return fetch({
    url: `${env.API_MSP}/bu-configs/${buCode}`,
    method: "get",
  });
};

// Create Business Unit Config
BusinessUnitService.createBusinessUnitConfig = ({ data }) => {
  return fetch({
    url: `${env.API_MSP}/bu-configs`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Update Business Unit Config
BusinessUnitService.updateBusinessUnitConfig = ({ id, data }) => {
  return fetch({
    url: `${env.API_MSP}/bu-configs/${id}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// List Provinces
BusinessUnitService.listProvinces = () => {
  return fetch({
    url: `${env.API_MSP}/localities`,
    method: "get",
    params: {
      "filter[locality_type_id]": 1,
      "filter[record_status]": "O",
      page: -1,
    },
  });
};

// List Districts
BusinessUnitService.listDistricts = parentId => {
  return fetch({
    url: `${env.API_MSP}/localities`,
    method: "get",
    params: {
      "filter[locality_type_id]": 2,
      "filter[record_status]": "O",
      "filter[parent_id]": parentId,
      page: -1,
    },
  });
};

// Add Identification
BusinessUnitService.addIndentification = data => {
  return fetch({
    url: `${env.API_MSP}/bu-cas`,
    method: "post",
    data: { ...data },
  });
};

// Get Identification List
BusinessUnitService.getIdentificationList = buCode => {
  return fetch({
    url: `${env.API_MSP}/bu-cas/${buCode}`,
    method: "get",
  });
};

export default BusinessUnitService;
